import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import Styled from '../Styled';
import IconWithWord from './MuiIconWithWord';

// js codes
import { USER_HISTORIES } from '../../../constants/routing';

const { IconWrapper, IconLink } = Styled;

interface Props {}
const UserHistoryIconLink: VFC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink href={USER_HISTORIES}>
        <IconWithWord Icon={HistoryIcon} word={t('header.menu.histories')} />
      </IconLink>
    </IconWrapper>
  );
};

export default UserHistoryIconLink;
